/* eslint-disable import/prefer-default-export */
import { GrowthBook } from '@growthbook/growthbook-react';
import { LocalStorageStickyBucketService } from '@growthbook/growthbook';

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.REACT_APP_GROWTHBOOK_KEY,
  enableDevMode: process.env.REACT_APP_TEMP_MEE_ENV === 'development',
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    console.log('Experiment Viewed', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
  stickyBucketService: new LocalStorageStickyBucketService(),
});

export const setJobAttributes = async (job) => {
  await growthbook.setAttributes({
    ...growthbook.getAttributes(),
    job: {
      state: job?.state,
    },
  });
};

export const getShouldAllowAdminToPostProcedure = () =>
  growthbook.isOn('should-allow-admin-to-post-procedure');
export const getShouldShowWhoCanSeeThisShift = () =>
  growthbook.isOn('should-show-who-can-see-this-shift');
export const shouldUseOfficeService = () => growthbook.isOn('use-office-service');
export const getShouldUseCredentialServiceProfessionCount = () =>
  growthbook.isOn('use-credential-service-profession-count');
export const getShouldUsingCredentialServiceEndpoint = () =>
  growthbook.isOn('should-use-credential-service-endpoint');
export const getShouldOfficeUnlimitedApplicationEnabled = () =>
  growthbook.isOn('unlimited-application-enabled-states');

export const getShouldShowDSORAMManagerCard = () =>
  growthbook.isOn('TEMP-12184-show-dso-ram-manager-card');

export const getShouldAllowOfficeToPostProcedureBasedOnProfession = () =>
  growthbook.isOn('TEMP-11985-should-allow-office-to-post-procedure-based-on-profession');
export const getOffersToBestProfessionalsValue = () =>
  growthbook.getFeatureValue('TEMP-9245-offers-to-best-professionals', null);

export const getChangeChargeTimelineValue = () =>
  growthbook.getFeatureValue(
    'TEMP-12852-admin-create-an-ui-for-updating-timeline-for-charge-in-the-office-details',
    null,
  );

/**
 * return as string
 * e.g : +18558794688
 */
export const getShouldUseCSPhone = () => growthbook.getFeatureValue('TEMP-13494-CS-phone');

export const getShouldEnablePermanentJobV2 = () =>
  growthbook.isOn('ARF-30-enable-permanent-job-v2-admin-panel');

export const getShouldUseAttestation = () =>
  growthbook.isOn('TEMP-13710-should-use-attestiontion-fe');

export const getShouldUseProtectedS3Licenses = () =>
  growthbook.isOn('TEMP-14744-use-protected-s3-licenses');

export const getShouldUseTrinetI9StatusTracking = () =>
  growthbook.isOn('TEMP-10958-enable-i9-status-tracking');

export const getShouldShowConsolidatedInvoices = () =>
  growthbook.isOn('TEMP-14775-enable-consolidated-invoices');
